module.exports = __webpack_public_path__ + "static/media/personal_pic.c7ff3174.webp";